import request from '@/common/request.js'

export default {
  // 获取课时信息
  getLesson(lessonId) {
    return request.get('/api/v2/Lesson/getLesson', {params: {lesson_id: lessonId}})
  },
  // 获取课时视频播放进度
  getLessonLiveProccess(courseId, lessonId, lessonType) {
    return request.get('/api/v2/Live_history/getVideoTime', {params:{course_id:courseId,lesson_id:lessonId,lesson_type:lessonType}})
  },
  // 获取课时视频播放进度
  getCourseLesson(courseId) {
    return request.get('/api/v2/course/getCourseLesson', {params:{course_id:courseId}})
  },
  // 课时视频增加观看次数
  addLessonVideoTime(courseId, lessonId, lessonType) {
    return request.post('/api/v2/Live_history/addTotal', {course_id: courseId, lesson_id: lessonId, lesson_type: lessonType})
  },
  // 增加课程视频观看时长
  addLessonVideoLookTime(courseId, lessonId, lessonType, seeVideoTime, lastTime, arrayData, terminal) {
    const data = {
      array_data: arrayData,
      course_id: courseId,
      lesson_id: lessonId,
      lesson_type: lessonType,
      last_time: lastTime,
      see_video_time: seeVideoTime,
      terminal: terminal
    }
    return request.post('/api/v2/Live_history/addTime', data)
  },
}



// WEBPACK FOOTER //
// ./src/apis/course/course.js